import { Location } from '@angular/common';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@services/auth.service';
import { LoadingService } from '@services/loading.service';

import {
  AlertDialogComponent,
  DialogOption as AlertDialogOption,
} from '@components/shared/alert-dialog/alert-dialog.component';

import {
  ApiError,
  NotAuthenticatedUserError,
  NotSelectedTenantError,
} from './error';
import { MatDialog } from '@angular/material/dialog';

/**
 * エラーハンドラーサービス
 */
@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  /**
   * コンストラクタ
   * @param pageLeaveConfirmService ページ離脱確認サービス
   * @param authService 認証サービス
   * @param loadingService ローディングサービス
   * @param zone NgZoon
   * @param router Router
   * @param location Location
   */
  constructor(
    private authService: AuthService,
    private loadingService: LoadingService,
    private zone: NgZone,
    private router: Router,
    private location: Location,
    private dialog: MatDialog,
  ) {}

  /**
   * エラーハンドリング
   * @param error エラー
   */
  handleError(error: unknown): void {
    console.error(error);
    this.loadingService.clear();
    if (error instanceof ApiError) {
      if (error.response.status === 401 || error.response.status === 403) {
        this.handleAuthError();
      } else if (400 <= error.response.status && error.response.status < 500) {
        const alertDialogOptions: AlertDialogOption = {
          type: 'error',
          message: `不正な値が入力されておりました。\nご確認の上、もう一度お試しください。`,
        };
        this.dialog.open(AlertDialogComponent, {
          width: '600px',
          data: alertDialogOptions,
        });
      } else {
        this.navigateTo('/error');
      }
    } else if (error instanceof NotAuthenticatedUserError) {
      this.handleAuthError();
    } else if (error instanceof NotSelectedTenantError) {
      this.navigateTo('/tenant-select');
    } else {
      this.navigateTo('/error');
    }
  }

  /**
   * 認証認可エラーのハンドリング
   */
  private handleAuthError() {
    this.authService.logout();

    // ログイン画面からの認証認可エラーは何もしない。
    if (this.location.path() === '/login') {
      return;
    }

    this.navigateTo('/login');
  }

  /**
   * 画面遷移
   * @param url URL
   */
  private navigateTo(url: string) {
    // ここだときちんとAngularのイベントが発火しない可能性があるので
    // NgZone.run内で処理を記入する
    this.zone.run(() => {
      this.router.navigate([url]);
    });
  }
}
